import React from 'react';
import { Box, Typography, Link, CssBaseline } from '@material-ui/core';
import { grey } from '@material-ui/core/colors';
import { ThemeProvider } from '@material-ui/styles';
import { createMuiTheme } from '@material-ui/core/styles';
import purple from '@material-ui/core/colors/purple';

const theme = createMuiTheme({
  palette: {
    primary: {
      main: purple[500],
    },
    secondary: {
      main: '#f44336',
    },
  },
});

const gray = grey[400];

const Layout = ({ children }) => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box component="header" textAlign="center">
        <Typography component="h1" variant="h3">
          ดวงทูเดย์
        </Typography>
      </Box>
      <Box component="main" p={2}>
        {children}
      </Box>
      <Box component="footer" textAlign="center" py={2}>
        <Typography variant="caption" component="span" style={{ color: gray }}>
          &copy;2020{' '}
          <Link
            href="https://duangtoday.co.th"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: gray }}
          >
            duangtoday.co.th
          </Link>{' '}
          All rights reserved.
        </Typography>
      </Box>
    </ThemeProvider>
  );
};

export default Layout;
